import { Routes } from '@angular/router';
import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/auth-guard';

const redirectLoggedInToConsole = () => redirectLoggedInTo(['/console']);
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['/signin']);

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    loadComponent: () => import('./pages/accounts/login/login.component').then((m) => m.LoginComponent),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToConsole }
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/accounts/register/register.component').then((m) => m.RegisterComponent),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectLoggedInToConsole }
  },
  {
    path: 'console',
    loadChildren: () => import('./pages/console/console.routes').then((m) => m.ConsoleRoutes),
    canActivate: [AuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin }
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'account-deletion',
    loadComponent: () => import('./pages/account-deletion/account-deletion.component').then((m) => m.AccountDeletionComponent),
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: '404',
  }
];
